import React from 'react';
import { Col, Row } from 'react-grid-system';
import Loader from "../../common/components/Loader/Loader";
import './DashBoard.scss';
import DashboardServices from '../../services/Dashboard';
import { Chart } from 'react-chartjs-2';
import moment from 'moment';


import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import Helpers from '../../common/Helpers';
import { resource } from '../../common/lang/lang';
import { Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from '@material-ui/core';
import { AccountBox, Description, DirectionsBus, PeopleAltRounded } from '@material-ui/icons';
import Date from '../../common/components/Fields/Date';
import Provider from '../../common/components/Provider/Provider';
import { saveFormulariosData } from '../../common/Actions';
import Btn from '../../common/components/Btn/Btn';

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    BarController,
    Title,
    Tooltip,
    Legend
);

export const labels = ['Ejecutados', 'Pendientes'];

class DashBoard extends React.Component {

    Vehicles = resource('VehicleType');
    Cities = resource('Cities');
    primayColor = '#A6FD10';

    constructor(props) {
        super(props)
        this.state = {
            totalEjecutados: 0,
            totalPendientes: 0,
            options: {
                responsive: true,
                plugins: {
                    legend: {
                        position: 'top',
                    },
                    title: {
                        display: true,
                        text: 'Servicios',
                    },
                },
            },
            servicesByVehicleTypeData: [],
            servicesByVehicleTypeLabels: [],
            servicesByClientLabels: [],
            servicesByClientData: [],
            servicesByClientTotalValues: [],
            servicesByClient: [],
            totalPassengers: 0,
            totalServices: 0,
            totalVehicles: 0,
            totalDrivers: 0,
            salesByVehicleLabel: [],
            salesByVehicleData: [],
            drivers: [],
            vehicles: [],
            date: "",
            driverDate: "",
            vehicleDate: "",
            salesStartDate: "",
            salesEndDate: "",
            salesByCityStartDate: "",
            salesByCityEndDate: "",
            salesByVehicleStartDate: "",
            salesByVehicleEndDate: "",
            clientServicesStartDate: "",
            clientServicesEndDate: "",
            pageDrivers: 0,
            pageVehicles: 0,
            pageServices: 0,
            rowsPerPageDrivers: 10,
            rowsPerPageVehicles: 10,
            rowsPerPageServices: 10,
            reportStartDate: "",
            reportEndDate: "",
            loadingReport: false
        }
    }

    componentDidMount() {
        Loader.toogle(false);
        this.getData();
    }

    async getData() {

        this.getCounters();
        this.getDataDrivers();
        this.totalSalesByClient();
        this.getDataVehicles();
        this.salesByTypeVehicle();
        this.salesByCity();
        this.salesByVehicle();

    }

    async getDataDrivers(date = this.state.driverDate) {
        let { drivers, date: responseDate } = await DashboardServices.driversAvailables(date);
        console.log(typeof drivers);

        if (drivers) {
            this.setState({ drivers, driverDate: date });
        };
    }

    handleDriverDateChange = (date) => {
        const driverDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ driverDate }, () => this.getDataDrivers(driverDate));
    };

    async getDataVehicles(date = this.state.vehicleDate) {
        let { vehicles, date: responseDate } = await DashboardServices.vehiclesAvailable(date);
        if (vehicles) {
            this.setState({ vehicles, vehicleDate: date });
        }
    }

    handleVehicleDateChange = (date) => {
        const vehicleDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ vehicleDate }, () => this.getDataVehicles(vehicleDate));
    };

    async getCounters() {
        let { data } = await DashboardServices.counters()

        if (data) {
            let { totalPassengers, totalServices, totalVehicles, totalDrivers, } = data;
            this.setState({ totalPassengers, totalServices, totalVehicles, totalDrivers, })
        }
    }

    async sendEmail() {
        const data = await DashboardServices.sendEmail();
        console.log(data);
    }

    async salesByVehicle(startDate = this.state.salesByVehicleStartDate, endDate = this.state.salesByVehicleEndDate) {
        let { data } = await DashboardServices.salesByVehicle(startDate, endDate);
        let salesByVehicleLabel = [];
        let salesByVehicleData = [];

        if(data){
          for (const vehicle of data) {
              salesByVehicleLabel.push(vehicle.plate);
              salesByVehicleData.push(vehicle.total_value);
          }
        }

        this.setState({ salesByVehicleLabel, salesByVehicleData });

    }

    handleSalesByTypeStartDateChange = (date) => {
        const salesStartDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ salesStartDate }, () => this.salesByTypeVehicle(salesStartDate, this.state.salesEndDate));
    };

    handleSalesByTypeEndDateChange = (date) => {
        const salesEndDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ salesEndDate }, () => this.salesByTypeVehicle(this.state.salesStartDate, salesEndDate));
    };

    handleSalesByCityStartDateChange = (date) => {
        const salesByCityStartDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ salesByCityStartDate }, () => this.salesByCity(salesByCityStartDate, this.state.salesByCityEndDate));
    };

    handleSalesByCityEndDateChange = (date) => {
        const salesByCityEndDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ salesByCityEndDate }, () => this.salesByCity(this.state.salesByCityStartDate, salesByCityEndDate));
    };

    handleSalesByVehicleStartDateChange = (date) => {
        const salesByVehicleStartDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ salesByVehicleStartDate }, () => this.salesByVehicle(salesByVehicleStartDate, this.state.salesByVehicleEndDate));
    };

    handleSalesByVehicleEndDateChange = (date) => {
        const salesByVehicleEndDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ salesByVehicleEndDate }, () => this.salesByVehicle(this.state.salesByVehicleStartDate, salesByVehicleEndDate));
    };

    handleClientServicesStartDateChange = (date) => {
        const clientServicesStartDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ clientServicesStartDate }, () => this.totalSalesByClient(clientServicesStartDate, this.state.clientServicesEndDate));
    };

    handleClientServicesEndDateChange = (date) => {
        const clientServicesEndDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ clientServicesEndDate }, () => this.totalSalesByClient(this.state.clientServicesStartDate, clientServicesEndDate));
    };

    async totalSalesByClient(startDate = this.state.clientServicesStartDate, endDate = this.state.clientServicesEndDate) {
        let { data } = await DashboardServices.totalSalesByClient(startDate, endDate);

        this.setState({ servicesByClient: data });
    }

    async salesByTypeVehicle(startDate = this.state.salesStartDate, endDate = this.state.salesEndDate) {
        let { data } = await DashboardServices.salesByTypeVehicle(startDate, endDate);
        let salesByTypeVehicleLabel = [];
        let salesByTypeVehicleData = [];

        for (const vehicle of data) {
            salesByTypeVehicleLabel.push(Helpers.getStatic(vehicle.vehicle_type, this.Vehicles).name);
            salesByTypeVehicleData.push(vehicle.total_value);
        }

        this.setState({ salesByTypeVehicleLabel, salesByTypeVehicleData });
    }

    async salesByCity(startDate = this.state.salesByCityStartDate, endDate = this.state.salesByCityEndDate) {
        let { data } = await DashboardServices.totalSalesByCity(startDate, endDate);
        let salesByCityLabels = []
        let salesByCityData = []

        for (const byCity of data) {
            salesByCityLabels.push(Helpers.getStatic(byCity.origen, this.Cities).name)
            salesByCityData.push(byCity.total_value)
        }

        this.setState({ salesByCityLabels, salesByCityData });
    }

    handleChangePageDrivers = (event, newPage) => {
        this.setState({ pageDrivers: newPage });
    };

    handleChangePageVehicles = (event, newPage) => {
        this.setState({ pageVehicles: newPage });
    };

    handleChangePageServices = (event, newPage) => {
        this.setState({ pageServices: newPage });
    };

    handleChangeRowsPerPageDrivers = event => {
        const value = parseInt(event.target.value, 10);
        this.setState({ rowsPerPageDrivers: value, pageDrivers: 0 });
    };

    handleChangeRowsPerPageVehicles = event => {
        const value = parseInt(event.target.value, 10);
        this.setState({ rowsPerPageVehicles: value, pageVehicles: 0 });
    };

    handleChangeRowsPerPageServices = event => {
        const value = parseInt(event.target.value, 10);
        this.setState({ rowsPerPageServices: value, pageServices: 0 });
    };

    handleReportStartDateChange = (date) => {
        const reportStartDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ reportStartDate });
    };

    handleReportEndDateChange = (date) => {
        const reportEndDate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.setState({ reportEndDate });
    };

    downloadBase64File = (base64Data, fileName) => {
        try {
            const byteCharacters = atob(base64Data);
            const byteNumbers = new Array(byteCharacters.length);
            for (let i = 0; i < byteCharacters.length; i++) {
                byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            const byteArray = new Uint8Array(byteNumbers);
            const blob = new Blob([byteArray], { type: 'application/pdf' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Error al descargar el archivo:', error);
            alert('Error al descargar el archivo');
        }
    };

    downloadReport = async () => {
        const { reportStartDate, reportEndDate } = this.state;

        if (!reportStartDate || !reportEndDate) {
            alert('Por favor selecciona ambas fechas');
            return;
        }

        this.setState({ loadingReport: true });

        try {
            
            const data = await DashboardServices.downloadReport(reportStartDate, reportEndDate);

            console.log(data);
            

            if (data && data.base64) {
                this.downloadBase64File(data.base64, `reporte_${reportStartDate}_${reportEndDate}.pdf`);
            } else {
                alert('No se pudo generar el reporte');
            }

            // alert('Servicio no configurado. Por favor implementar downloadReport en DashboardServices');
        } catch (error) {
            console.error('Error al descargar el reporte:', error);
            alert('Error al descargar el reporte');
        } finally {
            this.setState({ loadingReport: false });
        }
    };

    view = id => () => this.props.history.push(`/servicio/view/${id}`);

    render() {
        let {
            totalServices,
            servicesByClient, totalPassengers, totalVehicles, totalDrivers, salesByCityLabels, salesByCityData, salesByTypeVehicleLabel, salesByTypeVehicleData, salesByVehicleLabel, salesByVehicleData, drivers, date, vehicles, pageDrivers, pageVehicles, pageServices, rowsPerPageDrivers, rowsPerPageVehicles, rowsPerPageServices
        } = this.state;

        const paginatedDrivers = Array.isArray(drivers) ? drivers.slice(pageDrivers * rowsPerPageDrivers, pageDrivers * rowsPerPageDrivers + rowsPerPageDrivers) : [];
        const paginatedVehicles = Array.isArray(vehicles) ? vehicles.slice(pageVehicles * rowsPerPageVehicles, pageVehicles * rowsPerPageVehicles + rowsPerPageVehicles) : [];
        const paginatedServices = Array.isArray(servicesByClient) ? servicesByClient.slice(pageServices * rowsPerPageServices, pageServices * rowsPerPageServices + rowsPerPageServices) : [];

        return (
            <div className="dashboard-page">
                <Provider save={saveFormulariosData} store="formularios">
                    <Row>
                        <Col>
                            <div className='card-dashboard'>
                                <div>
                                    <h1>Pasajeros transportados</h1>
                                    <h4>{Number(totalPassengers).toLocaleString("es-ES")}</h4>
                                </div>
                                <div className='icon'>
                                    <PeopleAltRounded fontSize='large' color='primary' />
                                </div>
                            </div>
                        </Col>
                        {/* <button onClick={this.sendEmail}>Enviar Correo</button> */}
                        <Col>
                            <div className='card-dashboard'>
                                <div>
                                    <h1>Cantidad de servicios</h1>
                                    <h4>{Number(totalServices).toLocaleString("es-ES")}</h4>
                                </div>
                                <div className='icon'>
                                    <Description fontSize='large' color='primary' />
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='card-dashboard'>
                                <div>
                                    <h1>Total de vehículos</h1>
                                    <h4>{Number(totalVehicles).toLocaleString("es-ES")}</h4>
                                </div>
                                <div className='icon'>
                                    <DirectionsBus fontSize='large' color='primary' />
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className='card-dashboard'>
                                <div>
                                    <h1>Total de conductores</h1>
                                    <h4>{Number(totalDrivers).toLocaleString("es-ES")}</h4>
                                </div>
                                <div className='icon'>
                                    <AccountBox fontSize='large' color='primary' />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="formdata">
                                <div className="wrap">
                                    <h1 style={{ marginBottom: 30 }}>Conductores disponibles</h1>
                                    <Date label="Fecha a listar" name="fecha_conductores" change={this.handleDriverDateChange} />
                                    <div className='table'>
                                        <TableContainer>
                                            <Table size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: "bold" }}>Nombre conductor</TableCell>
                                                        <TableCell style={{ fontWeight: "bold" }}>Apellído conductor</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        paginatedDrivers.map((driver) => {
                                                            const { id, name, surname } = driver;
                                                            return (
                                                                <TableRow key={id} >
                                                                    <TableCell>{name}</TableCell>
                                                                    <TableCell>{surname}</TableCell>
                                                                </TableRow>
                                                            )
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={drivers.length}
                                                page={pageDrivers}
                                                onPageChange={this.handleChangePageDrivers}
                                                rowsPerPage={rowsPerPageDrivers}
                                                onRowsPerPageChange={this.handleChangeRowsPerPageDrivers}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                            />
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        </Col>
                        <Col>
                            <div className="formdata">
                                <div className='wrap table'>
                                    <h1 style={{ marginBottom: 30 }}>Vehiculos disponibles</h1>
                                    <Date label="Fecha a mostrar" name="fecha_vehiculo" change={this.handleVehicleDateChange} />
                                    <div className='table'>
                                        <TableContainer>
                                            <Table size='small'>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell style={{ fontWeight: "bold" }}>Nombre vehículo</TableCell>
                                                        <TableCell style={{ fontWeight: "bold" }}>Placa</TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {
                                                        paginatedVehicles.map(({ id, marca, plate }) => (
                                                            <React.Fragment key={id}>
                                                                <TableRow>
                                                                    <TableCell>{marca}</TableCell>
                                                                    <TableCell>{plate}</TableCell>
                                                                </TableRow>
                                                            </React.Fragment>
                                                        ))
                                                    }
                                                </TableBody>
                                            </Table>
                                            <TablePagination
                                                component="div"
                                                count={vehicles.length}
                                                page={pageVehicles}
                                                onPageChange={this.handleChangePageVehicles}
                                                rowsPerPage={rowsPerPageVehicles}
                                                onRowsPerPageChange={this.handleChangeRowsPerPageVehicles}
                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                            />
                                        </TableContainer>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className='formdata'>
                                <div className='wrap' style={{ minHeight: 200 }}>
                                    <h1 style={{ marginBottom: 30 }}>Descargar Reporte</h1>
                                    <div>
                                        <Date label={"Fecha inicio"} name={"report_start_date"} change={this.handleReportStartDateChange} />
                                        <Date label={"Fecha fin"} name={"report_end_date"} change={this.handleReportEndDateChange} />
                                    </div>
                                    <Btn type={"primary"}
                                        text={this.state.loadingReport ? 'Descargando...' : 'Descargar Reporte PDF'}
                                        click={this.downloadReport}
                                        disabled={this.state.loadingReport}
                                        class={'btn-block'}
                                    />
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className='formdata'>
                                <Row>
                                    <Col className='wrap'>
                                        <h1 style={{ marginBottom: 30 }}>Ventas por tipo de vehículo</h1>

                                        <div>
                                            <Date label={"Fecha inicio"} name={"start_date_sales_type_vehicle"} change={this.handleSalesByTypeStartDateChange} />
                                            <Date label={"Fecha fin"} name={"end_date_sales_type_vehicle"} change={this.handleSalesByTypeEndDateChange} />
                                        </div>

                                        <Chart type='bar'
                                            options={{
                                                plugins: {
                                                    legend: {
                                                        position: 'top'
                                                    }
                                                },
                                                scales: {
                                                    y: {
                                                        ticks: {
                                                            callback: function (value) {
                                                                return Number((value / 1000000).toFixed(0)).toLocaleString('es-CO') + ' M'; // 1.000.000.000 → 1.000M
                                                            },
                                                        },
                                                        title: {
                                                            display: true,
                                                            text: 'Millones (M)',
                                                        },
                                                    }
                                                }
                                            }}
                                            data={{
                                                labels: salesByTypeVehicleLabel,
                                                datasets: [
                                                    {
                                                        id: 1,
                                                        label: "Ventas por tipo de vehículo",
                                                        data: salesByTypeVehicleData,
                                                        backgroundColor: this.primayColor
                                                    }
                                                ],
                                            }} />
                                    </Col>

                                </Row>
                            </div>
                        </Col>
                        <Col>
                            <div className='formdata'>
                                <div className='wrap'>
                                    <h1 style={{ marginBottom: 30 }}>Ventas por ciudad de origen</h1>
                                    <div>
                                        <Date label={"Fecha inicio"} name={"start_date_sales_by_city"} change={this.handleSalesByCityStartDateChange} />
                                        <Date label={"Fecha fin"} name={"end_date_sales_by_city"} change={this.handleSalesByCityEndDateChange} />
                                    </div>
                                    <Chart type='bar'
                                        options={{
                                            plugins: {
                                                legend: {
                                                    position: 'top'
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        callback: function (value) {
                                                            return Number((value / 1000000).toFixed(0)).toLocaleString('es-CO') + ' M'; // 1.000.000.000 → 1.000M
                                                        },
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: 'Millones (M)',
                                                    },
                                                }
                                            }

                                        }}
                                        data={{
                                            labels: salesByCityLabels,
                                            datasets: [
                                                {
                                                    id: 1,
                                                    label: "Total por ciudad (10 mejores - Origen)",
                                                    data: salesByCityData,
                                                    backgroundColor: this.primayColor
                                                }
                                            ],
                                        }} />
                                </div>
                            </div>
                        </Col>

                    </Row >
                    <Row style={{ padding: 0 }}>
                        <Col style={{ padding: 0 }}>
                            <div className='formdata'>
                                <div className="wrap table">
                                    <h1 style={{ fontSize: 20, textAlign: 'center', color: 'grey', marginBottom: 30 }}>Clientes con mas servicios</h1>
                                    <div>
                                        <Date label={"Fecha inicio"} name={"start_date_services_clients"} change={this.handleClientServicesStartDateChange} />
                                        <Date label={"Fecha fin"} name={"end_date_services_clients"} change={this.handleClientServicesEndDateChange} />
                                    </div>
                                    <TableContainer>
                                        <Table size='small'>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell style={{ fontWeight: "bold" }}>Cliente</TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }}>Números de servicios</TableCell>
                                                    <TableCell style={{ fontWeight: "bold" }}>Total</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    paginatedServices.map((item, index) => (
                                                        <React.Fragment key={item.client}>
                                                            <TableRow>
                                                                <TableCell>{item.client_name}</TableCell>
                                                                <TableCell>{`${item.amount}`}</TableCell>
                                                                <TableCell>{Helpers.formatToMask(item.total_value)}</TableCell>
                                                            </TableRow>
                                                        </React.Fragment>
                                                    ))
                                                }
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            component="div"
                                            count={servicesByClient.length}
                                            page={pageServices}
                                            onPageChange={this.handleChangePageServices}
                                            rowsPerPage={rowsPerPageServices}
                                            onRowsPerPageChange={this.handleChangeRowsPerPageServices}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                        />
                                    </TableContainer>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className='formdata'>
                                <div className='wrap'>
                                    <h1 style={{ marginBottom: 30 }}>Ventas por vehículo</h1>
                                    <div>
                                        <Date label={"Fecha inicio"} name={"start_date_sales_by_vehicle"} change={this.handleSalesByVehicleStartDateChange} />
                                        <Date label={"Fecha fin"} name={"end_date_sales_by_vehicle"} change={this.handleSalesByVehicleEndDateChange} />
                                    </div>
                                    <Chart type='bar'
                                        options={{
                                            plugins: {
                                                legend: {
                                                    position: 'top',
                                                    labels: {
                                                        boxWidth: 100
                                                    }
                                                }
                                            },
                                            scales: {
                                                y: {
                                                    ticks: {
                                                        callback: function (value) {
                                                            return Number((value / 1000000).toFixed(0)).toLocaleString('es-CO') + ' M'; // 1.000.000.000 → 1.000M
                                                        },
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: 'Millones (M)',
                                                    },
                                                }
                                            }
                                        }}
                                        data={{
                                            labels: salesByVehicleLabel,
                                            datasets: [
                                                {
                                                    id: 1,
                                                    label: "Total ($) por vehículo",
                                                    data: salesByVehicleData,
                                                    backgroundColor: this.primayColor
                                                }
                                            ],
                                        }} />
                                </div>
                            </div>
                        </Col>
                    </Row>

                </Provider>
            </div >
        );
    }
}

export default DashBoard;
